import React from 'react';
import moment from 'moment';
import { Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { GetBarCode } from '../utils';
import RupeeFit from '../../assets/rupeeFit.png';
import Disclimer from '../../assets/disclimer.png';
import {
  getSplitDescription,
  truncatedNumber,
  truncateString
} from '../../../../utils/index';
import Warranty from './warranty';

import fonts from '../../assets/Fonts';
import _ from 'lodash';

Font.register(fonts);

const styles = StyleSheet.create({
  card: {
    fontFamily: 'OpenSans',
    height: '210mm',
    width: '297mm'
  },
  qrwithname: {
    display: 'flex',
    flexDirection: 'row',
    height: '84.8mm'
  },
  qrcode: {
    width: '82.8mm',
    height: '84.8mm',
    padding: '2mm 1mm',
    borderRight: '1 solid #000000'
  },
  productnameWithDesc: {
    width: '200mm',
    // padding: '3mm 4mm',
    paddingTop: '4mm',
    paddingLeft: '4mm'
  },
  productname: {
    fontSize: '22.63pt',
    // padding: '3mm 4mm'
    paddingLeft: '2mm',
    lineHeight: '0.4mm',
    paddingBottom: '7mm'
  },
  description: {
    padding: '3mm 4mm'
  },

  mrpText: {
    fontWeight: 'bold',
    color: 'black'
  },
  rupeeSmall: {
    width: '7mm',
    height: '7mm'
  },
  mrp: {
    width: '100mm',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingBottom: '9mm',
    fontSize: '28.83pt'
  },
  priceBlock: {
    borderTop: '1 solid #000000',
    borderBottom: '1 solid #000000',
    display: 'flex',
    flexDirection: 'row',
    height: '180px'
  },
  pricewithRupeeIcon: {
    display: 'flex',
    flexDirection: 'row',
    width: '200mm'
  },
  rupeeicon: {
    fontSize: '48pt',
    width: '10mm',
    paddingTop: '10mm',
    paddingLeft: '5mm'
  },
  price: {
    fontFamily: 'OpenSans',
    fontWeight: 'bold',
    fontSize: '155pt',
    textAlign: 'left',
    color: 'black',
    paddingLeft: '10mm',
    top: -22,
    lineHeight: 1
  },
  inclTax: {
    paddingTop: '53mm',
    left: -40,
    fontSize: '8.9pt'
  },

  //   Footer
  footer: {
    padding: '6mm 10mm '
  },
  dateDetails: {
    marginTop: -10,
    display: 'flex',
    flexDirection: 'row'
  },
  itemCode: {
    paddingTop: '15mm',
    fontSize: '12pt',
    opacity: '1',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  barcodeBlock: {
    width: '190mm',
    textAlign: 'right',
    justifyContent: 'center',
    alignItems: 'right'
  },
  warrantyText: {
    fontSize: '12.74pt',
    color: '#1A1818',
    opacity: '1'
  },
  barcode: {
    width: '45mm',
    padding: '1mm 1mm 0mm 0mm'
  },
  // lineHeight: { paddingLeft: '4mm },
  disclimer: {
    width: '5.75mm',
    height: '5.75mm',
    left: 5
  }
});

const A4Landscape = ({ data, count, ...rest }) => {
  return (
    <Page size="A4" orientation="landscape" style={styles.page}>
      {count &&
        count.map(id => (
          <View key={id} style={{ display: 'flex' }}>
            {data?.map(item => {
              return (
                <View style={styles.card} key={item?.id}>
                  <View style={styles.qrwithname}>
                    <View style={styles.qrcode}>
                      <Image src={item.image} />
                    </View>
                    <View style={styles.productnameWithDesc}>
                      <View style={styles.productname}>
                        <Text>
                          {truncateString(item?.product?.masterData?.name, 130)}
                        </Text>
                      </View>
                      <View
                        style={{
                          fontSize: '15.64pt',
                          paddingLeft: '2mm',
                          lineHeight: '1.4'
                        }}
                      >
                        {/*<Text style={styles.lineHeight}>
                          {truncateString(
                            item?.description ||
                              item?.product?.masterData?.description ||
                              '',
                            130
                          )}
                        </Text>*/}
                        {/* placeholder content here */}
                        <View style={{ paddingTop: '7mm' }}>
                          {getSplitDescription(item.description, 5).map(
                            (line, index) => (
                              <Text key={index}>+ {line}</Text>
                            )
                          )}
                        </View>
                      </View>
                    </View>
                  </View>
                  <View style={styles.priceBlock}>
                    <View style={styles.pricewithRupeeIcon}>
                      <Text style={styles.rupeeicon}>
                        <Image src={RupeeFit} />
                      </Text>
                      <Text style={styles.price}>
                        {truncatedNumber(item?.product?.mop, 6)}
                      </Text>
                      <Text style={styles.inclTax}>*Incl. Tax</Text>
                    </View>
                    <View style={styles.mrp}>
                      {truncatedNumber(item?.product?.mrp, 6) > 0 ? (
                        <Text>
                          <Text style={styles.mrpText}>MRP: </Text>
                          <Image style={styles?.rupeeSmall} src={RupeeFit} />
                          {truncatedNumber(item?.product?.mrp, 6)}
                        </Text>
                      ) : (
                        <Text />
                      )}
                    </View>
                  </View>
                  <View style={styles?.footer}>
                    <View
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <View
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginLeft: -15
                        }}
                      >
                        <Warranty warranty={item.warranty} styles={styles} />
                      </View>
                      <View
                        style={
                          item?.warranty
                            ? styles.barcodeBlock
                            : { ...styles.barcodeBlock, marginTop: '15mm' }
                        }
                      >
                        <View style={styles.barcode}>
                          {_.isEmpty(item.barcode) ? (
                            <></>
                          ) : (
                            <Image src={GetBarCode(item?.barcode)} />
                          )}
                        </View>
                      </View>
                    </View>
                    <View
                      style={
                        item?.warranty
                          ? styles.dateDetails
                          : { ...styles.dateDetails, marginTop: '5mm' }
                      }
                    >
                      <View style={styles.itemCode}>
                        <Text>
                          {item.sku} | {item.class} | A |{' '}
                          {moment(item?.date).format('DD.MM.YYYY')} |{' '}
                          {moment().format('DD.MM.YYYY')}
                        </Text>
                        <View>
                          <Image style={styles.disclimer} src={Disclimer} />
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              );
            })}
          </View>
        ))}
    </Page>
  );
};
export { A4Landscape };
